import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function ProductCard({ product, index }) {
  return (
    <Link
      to={`/products#${product.slug}`}
      data-testid={`product-card-${product.slug}`}
      className="group relative bg-[var(--bg-primary)] border border-[rgba(107,31,34,0.12)] hover:border-[var(--maroon-700)] card-hover block"
    >
      <div className="aspect-[4/3] overflow-hidden bg-[var(--bg-secondary)] relative">
        {product.image ? (
          <img
            src={product.image}
            alt={product.name}
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            loading="lazy"
          />
        ) : (
          <div className="w-full h-full grid place-items-center text-[var(--maroon-700)] font-display text-2xl">
            {product.name.charAt(0)}
          </div>
        )}
        <div className="absolute top-3 left-3 font-mono-accent text-[11px] tracking-[0.2em] uppercase bg-[var(--maroon-950)]/85 text-[#FDFBF7] px-2.5 py-1">
          {String(index + 1).padStart(2, "0")} / Series
        </div>
      </div>

      <div className="p-6 md:p-7">
        <div className="flex items-start justify-between gap-4">
          <h3 className="font-display text-xl md:text-2xl text-[var(--maroon-950)] leading-tight">
            {product.name}
          </h3>
          <ArrowUpRight
            size={22}
            className="text-[var(--maroon-700)] shrink-0 transition-transform group-hover:rotate-12"
          />
        </div>
        <p className="mt-2 text-sm text-[var(--text-secondary)] italic font-display">
          {product.tagline}
        </p>
        <p className="mt-4 text-[15px] leading-relaxed text-[var(--text-secondary)] line-clamp-3">
          {product.description}
        </p>
      </div>
    </Link>
  );
}
